import React from 'react'

const CelebrityChefMenuIpad = () => {
    return (
        <div>CelebrityChefMenuIpad</div>
    )
}

export default CelebrityChefMenuIpad